import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { CreateRoomEventAdapter } from '~analytics/adapters/CreateRoomEventAdapter';
import { translate } from '~l10n/client';

import { roomsKeys } from '~teacher/hook/room/roomsKeys';
import { queryClient } from '~teacher/queryClient';
import view from 'AddRoomView';
import Constants from 'Constants';
import dots from 'Dots';
import RoomModel from 'RoomModel';
import utils from 'Utils';

import IntercomService from '../../../intercom/IntercomService';

let model = null;

class AddRoomController {
  open(props) {
    model = new RoomModel();
    model.callback = props.callback;

    let container = document.createElement('div');
    container.id = 'add-room-modal-container';
    document.body.appendChild(container);

    controller.renderView();
  }

  renderView() {
    ReactDOM.render(
      React.createElement(view, {
        controller: controller,
        model: model,
      }),
      document.getElementById('add-room-modal-container'),
      () => {
        if (!model.pageBlurred) {
          model.pageBlurred = true;
          utils.blurPage();
        }
      }
    );
  }

  nameChanged(name) {
    model.name = name;
    model.nameStatus.error = false;
    model.nameStatus.message = '';
    controller.renderView();
  }

  addClicked() {
    model.name = model.name.trim();

    if (model.name.length === 0) {
      model.nameStatus.error = true;
      model.nameStatus.message = '';
    } else if (!model.isValidName()) {
      model.nameStatus.error = true;
      model.nameStatus.message = translate(
        'Only letters (A-Z) and numbers are allowed in a room name.'
      );
    } else {
      dots.start('addRoomButton');

      model.addRoom(controller.addRoomResult);
    }

    controller.renderView();
  }

  /**
   * Callback for when a room is added.
   */
  addRoomResult(error, room) {
    IntercomService.event('create-room');

    if (error) {
      model.nameStatus.error = true;

      if (error.code === Constants.ROOM_ALREADY_EXISTS) {
        model.nameStatus.message = translate(
          'That room name is not available.'
        );
      } else {
        model.nameStatus.message = translate(
          'An unknown error occurred. Please try again later.'
        );
      }

      dots.stop();
      controller.renderView();
    } else {
      // This keeps the query client cache in sync with the rest of rooms.
      queryClient.refetchQueries(roomsKeys.all);
      // Successfully created a room.
      new CreateRoomEventAdapter().sendAnalytics();
      controller.cancelClicked();
      model.callback(room);
    }
  }

  cancelClicked() {
    let container = document.getElementById('add-room-modal-container');
    ReactDOM.unmountComponentAtNode(container);
    container.parentNode.removeChild(container);
    utils.unblurPage();
  }
}

let controller = new AddRoomController();
module.exports = controller;
